import { parseDateToLgComun4 } from "../../../helpers/dateTransform";

const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'es';

const Kinds = {
  'report': {
    'es': 'reportes',
    'en': 'reports',
    'de': 'Berichte',
    'fr': 'rapports',
    'pt-BR': 'denúncias',
  },
  'involved': {
    'es': 'involucrados',
    'en': 'involved',
    'de': 'Beteiligte',
    'fr': 'impliqués',
    'pt-BR': 'envolvidos',
  },
  'investigation': {
    'es': 'investigación',
    'en': 'investigation',
    'de': 'Untersuchung',
    'fr': 'enquête',
    'pt-BR': 'investigação',
  },
  'servicenow': {
    'es': 'ServiceNow',
    'en': 'ServiceNow',
    'de': 'ServiceNow',
    'fr': 'ServiceNow',
    'pt-BR': 'ServiceNow',
  },
  'other': {
    'es': 'Excel',
    'en': 'Excel',
    'de': 'Excel',
    'fr': 'Excel',
    'pt-BR': 'Excel',
  },
};

/**
 * Etiqueta del tipo de archivo en el idioma activo.
 *
 * Cae en 'Excel' tanto si el kind no esta traducido como si el backend manda
 * uno que este front todavia no conoce: antes `Kinds[kind][lang]` reventaba
 * la tabla completa con "Cannot read properties of undefined".
 */
const kindLabel = (kind) => Kinds[kind]?.[lang] ?? Kinds.other[lang] ?? 'Excel';

const createName = (kind, created, transalations, alias) => {
  const processedKind = kindLabel(kind);

  try {
    return `${transalations.nameFirst} ${processedKind} ${transalations.nameSecond} ${created}`;
  } catch {
    return '';
  }
};

const setFileData = (fileData, translations) => {
  const alias = fileData.alias ?? '';
  const kind = fileData.kind ?? 'other';
  const name = fileData.name ?? '';
  // El nombre del archivo usa la fecha sin sufijo; la lista muestra la etiquetada.
  const created_at = parseDateToLgComun4(fileData.created_at) ?? '';
  const created_at_label = parseDateToLgComun4(fileData.created_at, undefined, true) ?? '';
  const status = fileData.is_recent ?? false;

  // Fechas
  const currentDate = new Date();
  const createdDate = new Date(fileData.created_at);

  // Calcular la diferencia en días
  const millisecondsInADay = 24 * 60 * 60 * 1000;
  const daysDifference = Math.floor((currentDate - createdDate) / millisecondsInADay);
  const daysToExpire = 30 - daysDifference;

  // Determinar el estado de expiración
  let expires;
  if (daysToExpire > 0) {
    expires = `${daysToExpire} ${translations.days}`;
  } else {
    expires = translations.expired ?? 'Expired';
  }

  return {
    alias,
    name: !name ? createName(kind, created_at, translations, alias) : name,
    kind: kindLabel(kind),
    // Cruda: DetailFileModal la vuelve a formatear con new Date().
    created_at: fileData.created_at ?? '',
    created_at_label,
    status,
    expires,
    range_date: fileData.range_date,
    template_name: fileData.template__template_name,
    template_alias: fileData.template__alias,
    comment: fileData.comment,
    is_recent: fileData.is_recent,
  };
};

export default setFileData;